(function () {
  function rails(root) {
    root.querySelectorAll('[data-zkh-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-zkh-track]');
      var prev = rail.querySelector('[data-zkh-prev]');
      var next = rail.querySelector('[data-zkh-next]');
      if (!track || !prev || !next) return;
      function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
      function sync() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function videos(root) {
    root.querySelectorAll('[data-zkh-yt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.querySelector('iframe')) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(btn.getAttribute('data-zkh-yt')) + '?autoplay=1&rel=0';
        f.title = btn.getAttribute('data-zkh-yt-title') || 'Video';
        f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        f.allowFullscreen = true;
        btn.appendChild(f);
      });
    });
  }

  function copy(root) {
    root.querySelectorAll('[data-zkh-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-zkh-copy');
        var label = btn.querySelector('[data-zkh-copy-label]');
        var done = function () { if (label) { label.textContent = 'Copied'; setTimeout(function () { label.textContent = 'Copy'; }, 1800); } };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });
  }

  function reveal(root) {
    var items = root.querySelectorAll('[data-zkh-reveal]');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var i = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.transitionDelay = (i % 3) * 90 + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  function init(root) { rails(root); videos(root); copy(root); reveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
